export const COACHING_SECTIONS = [
    { id: 'roster', path: '', tabLabel: 'Přehled týmu', icon: '👥' },
    { id: 'compare', path: 'compare', tabLabel: 'Analýza výkonu', icon: '📈' },
];
